export const formatCurrency = (amount, currencySymbol) => {
  const formattedAmount = parseFloat(amount).toLocaleString();
  return `${currencySymbol}${formattedAmount}`;
};
